module.exports = __webpack_public_path__ + "img/share 1.42ca6aa9.svg";